// @ts-nocheck — verbatim port from xop-edge-staff. See src/crm/README.md.
import axios from './axios'

export interface CreateCustomerNoteData {
  content: string
  is_internal?: boolean
  is_pinned?: boolean
  note_date?: string
}

export interface UpdateCustomerNoteData {
  content?: string
  is_internal?: boolean
  is_pinned?: boolean
  note_date?: string
}

export interface CustomerNote {
  id: string
  content: string
  is_internal: boolean
  is_pinned: boolean
  active: boolean
  note_date: string
  formatted_note_date: string
  short_content: string
  author: {
    id: number
    name: string
  } | null
  last_updated_by?: {
    id: number
    name: string
  }
  created_at: string
  updated_at: string
}

export interface DetailedCustomerNote extends CustomerNote {
  customer: {
    id: string
    customer_id: string
    full_name: string
    email: string
    company_name: string
  }
}

export interface CustomerNotesResponse {
  notes: CustomerNote[]
  pagination: {
    current_page: number
    per_page: number
    total_count: number
  }
}

export interface CustomerNoteResponse {
  note: DetailedCustomerNote
}

interface CustomerNoteParams {
  page?: number
  per_page?: number
  author_id?: number
  from_date?: string
  to_date?: string
  search?: string
  sort?: 'note_date' | 'created_at' | 'author'
  direction?: 'asc' | 'desc'
}

class CustomerNotesApi {
  // Get all notes for a customer
  async getAll(customerId: string, params?: CustomerNoteParams): Promise<CustomerNotesResponse> {
    const response = await axios.get(`/customers/${customerId}/notes`, {
      params: params
    })
    return response.data
  }

  // Create a new note
  async create(customerId: string, noteData: CreateCustomerNoteData): Promise<CustomerNoteResponse> {
    const response = await axios.post(`/customers/${customerId}/notes`, {
      customer_note: noteData
    })
    return response.data
  }

  // Update a note
  async update(customerId: string, noteId: string, noteData: UpdateCustomerNoteData): Promise<CustomerNoteResponse> {
    const response = await axios.patch(`/customers/${customerId}/notes/${noteId}`, {
      customer_note: noteData
    })
    return response.data
  }

  // Delete a note
  async delete(customerId: string, noteId: string): Promise<{ message: string }> {
    const response = await axios.delete(`/customers/${customerId}/notes/${noteId}`)
    return response.data
  }
}

export const customerNotesApi = new CustomerNotesApi()
